import { useKpiTracker, useSession } from "@pocketrocketgmbh/kpi-tracker";

const config = {
  gameId: process.env.VUE_APP_GAME_ID || "",
  apiUrl: process.env.VUE_APP_API_URL || "",
  apiUsername: process.env.VUE_APP_API_USERNAME,
  apiPassword: process.env.VUE_APP_API_PASSWORD,
};

console.log('[useGameTracking] Config:', {
  gameId: config.gameId,
  apiUrl: config.apiUrl,
  hasUsername: !!config.apiUsername,
  hasPassword: !!config.apiPassword
});

// Singleton-Instanzen
let kpiTrackerInstance = null;
let sessionInstance = null;

export function useGameTracking() {
  // Erstelle Singleton-Instanzen nur einmal
  if (!kpiTrackerInstance || !sessionInstance) {
    console.log('[useGameTracking] About to call useKpiTracker. Window globals:', {
      hasVue: !!window.__VUE_INSTANCE__,
      hasCompositionApi: !!window.__VUE_COMPOSITION_API_INSTANCE__,
      hasRef: window.__VUE_COMPOSITION_API_INSTANCE__?.ref,
      compositionApiKeys: window.__VUE_COMPOSITION_API_INSTANCE__ ? Object.keys(window.__VUE_COMPOSITION_API_INSTANCE__).slice(0, 10) : []
    });
    // initialTimesLeftToPlay: Anzahl der Spiele, die ein Spieler spielen kann
    // Für dieses Spiel: 1 = Spieler kann 1x spielen
    kpiTrackerInstance = useKpiTracker(1);
    sessionInstance = useSession(config, kpiTrackerInstance);
  }

  return {
    kpiTracker: kpiTrackerInstance,
    session: sessionInstance,
  };
}
